import React from 'react';
import Modal from 'react-modal';
import Photos from "./photos";
import styled from "styled-components";
import { useMyContext } from '@/app/utils/MyContext';
import { useBodyScrollLock } from "@/app/utils/Common";
const CloseButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 24px 12px 0px 12px;
  gap: 10px;

  width: 100%;
  height: 48px;
  background-color:black;

  img
  {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`;

const customStyles = {
  content: {
    width: "100%",
    height: "100%",
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    marginRight: '0',
    padding: '0'
  },
  overlay : {
    zIndex: 160
  }
};

const PhotosViewer: React.FC<any> = (props: any) => {
  const {state:myContextState} = useMyContext();
  const {type, isOpen, onRequestClose, data} = props;
  useBodyScrollLock(isOpen);
  return (
    type==="pc" ? <Photos type={type} data={data}></Photos> :
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="">
        <CloseButtonDiv>
          <img onClick={onRequestClose} src={`${myContextState.assetPrefix}/commonImg/close.svg`}></img>
        </CloseButtonDiv>
        <Photos type={type} data={data}></Photos>
      </Modal>
  );
};
 
export default PhotosViewer